import { render, staticRenderFns } from "./SiteStats.vue?vue&type=template&id=5dfce80e&"
import script from "./SiteStats.vue?vue&type=script&lang=js&"
export * from "./SiteStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports